import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { getJobName } from "@wausauCustomBlueprint/Store/Data/PlaceOrder/JobNameSelector";
import { getShipComplete } from "@wausauCustomBlueprint/Store/Data/PlaceOrder/ShipCompleteSelector";


type cartStatusProps = Parameters<typeof SetCartStatus>[0];

addToChainAfter(chain, SetCartStatus, props => {
    const state = props.getState();
    props.cartToUpdate.properties = {
        ...props.cartToUpdate.properties,
        jobName: getJobName(props.getState() as any),
        shipComplete: getShipComplete(props.getState() as any).toString()
    };
});